import React from "react";
import ReactDOM from "react-dom/client";
import "./selectPortalDefaults";
/* 1. Design tokens (must be first) */
import "./styles/welinkDesignTokens.css";
import "bootstrap/dist/css/bootstrap.min.css";
/* 2. Base app styles */
import "./index.css";
import "./config/loadAppStyles";
import "./styles/responsiveOverrides.css";
import "./styles/rtlOverrides.css";
import "./styles/authSplit.css";
import "./styles/wljLocalUi.css";
import "./styles/wljIndustrialUi.css";
import "./styles/wljSafeUi.css";
import "./styles/wljResponsive.css";
/* 3. Foundation polish + screen tuning (last wins) */
import "./styles/wljFoundation.css";
import "./styles/wljScreenTuning.css";
import "./styles/wljThemeContrast.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { GoogleOAuthProvider } from "@react-oauth/google";
import AppPortalHost from "./components/Portal/AppPortalHost";
import ErrorBoundary from "./ErrorBoundary";
import { LOGIN_BANNER_URL } from "./config/staticAssets";
import { cleanupLegacyServiceWorkers } from "./utility/cacheCleanup";
import AppGradientBackground from "./components/NeatGradientCanvas/AppGradientBackground";
/* 4. Portal card glass (must load after gradient CSS) */
import "./styles/wljPortalGlass.css";
/* 5. Design system — final token-driven UI layer */
import "./styles/wljDesignSystem.css";
import { hideAppLoader } from "./utility/appLoader";
import { applyTheme, readStoredDarkMode } from "./utils/theme";

applyTheme(readStoredDarkMode());

if (typeof window !== "undefined" && "scrollRestoration" in window.history) {
  window.history.scrollRestoration = "manual";
}

document.documentElement.style.setProperty(
  "--wlj-login-banner-image",
  `url("${LOGIN_BANNER_URL}")`
);

cleanupLegacyServiceWorkers();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ErrorBoundary>
    <GoogleOAuthProvider clientId="1083740285274-tvvsachfqqlh5o9818f77dh55kko0nvs.apps.googleusercontent.com">
      <AppGradientBackground />
      <App />
      <AppPortalHost />
    </GoogleOAuthProvider>
  </ErrorBoundary>
);

hideAppLoader();
reportWebVitals();
